<template>
  <div class="form__field" :style="currStyle">
    <label :for="name" class="form__label">{{ label }}</label>
    <div class="form__control">
      <input
        class="form__input"
        :type="type"
        :id="name"
        :value="value"
        @input="input"
      />
    </div>
    <div
      class="form__message form__message--joined form__message--error"
      v-show="error"
    >
      <template v-if="name === 'firstname'">Falscher Name</template>
      <template v-else-if="name === 'lastname'">Falscher Vorname</template>
      <template v-else-if="name === 'username'">Falsche E-Mailadresse</template>
      <template v-else-if="name === 'password'">Falsche Passwort (Das Passwort muss mind. 8 Zeichen, einen Groß- und einen Kleinbuchstaben und eine Zahl enthalten)</template>
      <template v-else-if="name === 'zip'">Falsche PLZ</template>
      <template v-else-if="name === 'city'">Falsche Ort</template>
      <template v-else-if="name === 'street'">Falsche Straße</template>
      <template v-else-if="name === 'streetnumber'">Falsche Nr</template>
      <template v-else>Falsche {{ name.toLowerCase() }}</template>
    </div>
    <div
      class="form__description"
      v-show="description"
      v-html="description"
    ></div>
  </div>
</template>

<script>
export default {
  props: {
    name: String,
    label: String,
    type: String,
    value: String,
    error: Boolean,
    style: [Object, String],
    description: String,
  },
  data() {
    return {
      currStyle: this.style || { width: "30em" }
    };
  },
  methods: {
    input(e) {
      this.$emit("input", e.target.value);
    }
  }
};
</script>

<style scoped>

</style>
